import {Component, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Project} from '../dm/project';
import {Router} from '@angular/router';
import {NotificationService} from '../services/notification.service';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {UntypedFormControl} from '@angular/forms';
import {AuthenticationService} from '../services/authentication.service';
import {WarningModalComponentSQ} from './warning-modal/warning-modal.component';
import {HttpErrorService} from "../services/http.error.service";

@Component({
    selector: 'app-sonarqube',
    templateUrl: './sonarqube.component.html',
    styleUrls: ['./sonarqube.component.css']
})
export class SonarqubeComponent implements OnInit {
    isLoading = false;
    selectedProjects = new Set();
    dataSource = new MatTableDataSource<Project>([]);
    displayedColumns: string[] = ['id', 'name', 'sonarQubeProject', 'leader', 'course', 'enrolledStudents', 'selected', 'actions'];
    indeterminateV = false;
    courses = new Set();
    leaders = new Set();
    semesters = [];
    tags = new Set();
    basicFilter = '';
    courseFilter = '';
    leaderFilter = '';
    personFilter = '';
    archiveFilter = 'NONE';
    tagFilter = '';
    basicFilterControl = new UntypedFormControl();
    courseFilterControl = new UntypedFormControl();
    leaderFilterControl = new UntypedFormControl();
    personFilterControl = new UntypedFormControl();
    archiveFilterControl = new UntypedFormControl();
    tagFilterControl = new UntypedFormControl();

    constructor(private http: HttpClient,
                private router: Router,
                private notificationService: NotificationService,
                public authenticationService: AuthenticationService,
                public dialog: MatDialog,
                private httpErrorService: HttpErrorService) {
    }

    @ViewChild(MatSort) set matSort(sort: MatSort) {
        this.dataSource.sort = sort;
    }

    ngOnInit() {
        this.obtainSemesterLabels();
        this.archiveFilterControl.setValue('Nearchivované', {onlySelf: true, emitEvent: false});
        this.getProjects();
        this.dataSource.filterPredicate = (project: Project, filter: string = '') =>
            (
                ((this.courseFilter) ? (project.course.name === this.courseFilter) : true) &&
                ((this.authenticationService.isLoggedUserAdmin) ? true : (project.leader.id === this.authenticationService.loggedUserID)) &&
                ((this.leaderFilter) ? (project.leader.name === this.leaderFilter) : true) &&
                ((this.archiveFilter === 'NONE') ? (project.archive === null) : true) &&
                ((this.archiveFilter !== 'NONE' && this.archiveFilter !== 'ALL') ? (project.archive === this.archiveFilter) : true) &&
                (project.id.toString().indexOf(filter) !== -1 ||
                    project.name.toLowerCase().indexOf(filter) !== -1 ||
                    (project.databaseEA === null || project.databaseEA.name.toLowerCase().indexOf(filter) !== -1) ||
                    project.description.toLowerCase().indexOf(filter) !== -1
                ) &&
                ((this.personFilter) ? this.filterPersonFromProject(project, this.personFilter) : true)
            )
        ;
        this.dataSource.filter = sessionStorage.getItem('basicFilter') || '_';

        this.courseFilter = sessionStorage.getItem('courseFilter');
        this.leaderFilter = sessionStorage.getItem('leaderFilter');
        this.personFilter = sessionStorage.getItem('personFilter');
        this.archiveFilter = sessionStorage.getItem('archiveFilter');
        this.tagFilter = sessionStorage.getItem('tagFilter');


        this.basicFilterControl.setValue(sessionStorage.getItem('basicFilter'));
        this.courseFilterControl.setValue(sessionStorage.getItem('courseFilter'));
        this.leaderFilterControl.setValue(sessionStorage.getItem('leaderFilter'));
        this.personFilterControl.setValue(sessionStorage.getItem('personFilter'));
        this.archiveFilterControl.setValue(sessionStorage.getItem('archiveFilter'));
        this.tagFilterControl.setValue(sessionStorage.getItem('tagFilter'));
    }

    obtainSemesterLabels() {
        this.http.get<String[]>('/api/project/get-semesters')
            .subscribe(
                data => {
                    console.log(data);
                    this.semesters = data;
                },
                error => {
                    console.log("Semester labels haven't been obtained")
                }
            );
    }


    doFilter(query: string) {
        if (query) {
            this.dataSource.filter = query.trim().toLocaleLowerCase();
        } else {
            this.dataSource.filter = '_';
        }
    }


    addStudentToSonarQube(id: number) {
        this.http.post('/api/sonarqube/addusers', {projectId: id})
            .subscribe(response => {
                    this.notificationService.notify('Studenti byli přidáni úspěšne.');
                    this.getProjects();
                },
                error => {
                    if (!this.httpErrorService.ignoreError(error.status)) {
                        this.notificationService.notifyError('Přidání studentú se nezdařilo');
                    }
                    console.error('Couldn\'t add students.', error);
                }
            );
    }

    deleteSonarQube(id: number) {
        const dialogRef = this.dialog.open(WarningModalComponentSQ, {
            width: '500px',
            data: {isSonarQube: true, isDeleting: true}
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.isLoading = true;
                this.http.delete('/api/sonarqube/delete', {body: {projectId: id}})
                    .subscribe(
                        data => {
                            console.log('Delete successful ', data);
                            this.notificationService.notify('SonarQube úspěšne smazán.');
                            this.getProjects();
                            setTimeout(() => {
                                this.notificationService.clearNotification();
                            }, 12000);
                        },
                        error => {
                            console.error('Couldn\'t delete because', error);
                            this.getProjects();
                            if (!this.httpErrorService.ignoreError(error.status)) {
                                this.notificationService.notifyError('Chyba při mazání projektů: [' + error.status + '].');
                                setTimeout(() => {
                                    this.notificationService.clearNotification();
                                }, 12000);
                            }
                        }).add(() => {
                    this.isLoading = false;
                });
            }
        });
    }

    getProjects() {
        this.http.get<Project[]>('/api/project/all')
            .subscribe(
                data => {
                    this.dataSource.data = data;
                    for (const project of data) {
                        this.leaders.add(project.leader.name);
                        this.courses.add(project.course.name);
                        for (const tag of project.tags) {
                            this.tags.add(tag);
                        }
                    }
                    this.selectedProjects = new Set();
                    this.indeterminate();
                },
                error => {
                    console.error('Couldn\'t get because', error);
                    if (!this.httpErrorService.ignoreError(error.status)) {
                        this.notificationService.notifyError('Chyba při načítání projektů: [' + error.status + '].');
                        setTimeout(() => {
                            this.notificationService.clearNotification();
                        }, 12000);
                    }
                }
            );
    }

    edit(id: number) {
        this.router.navigate(['./project', id]);
    }

    createSonarQubeProjectsSelected() {

        const dialogRef = this.dialog.open(WarningModalComponentSQ, {
            width: '500px',
            data: {isSonarQube: true, isDeleting: false}
        });

        dialogRef.afterClosed().subscribe(result => {
            this.isLoading = true;
            if (result) {
                const idArray: number[] = this.collectSelectedIds();
                this.http.post<Array<number>>('/api/sonarqube/create-projects', {ids: idArray})
                    .subscribe(
                        data => {
                            if (data.length == idArray.length) {
                                this.notificationService.notify('SonarQube projekty vytvořeny úspešne. Studenti byli automaticky přidáni.');
                            } else {
                                this.notificationService.notifyError('SonarQube projekty byli neúspěšné pro projekty s id: (' + idArray.filter(value => !data.includes(value)) + ').');
                            }
                            setTimeout(() => {
                                this.notificationService.clearNotification();
                            }, 12000);
                            this.getProjects();
                        },
                        error => {
                            console.error('Couldn\'t archive because', error);
                            if (!this.httpErrorService.ignoreError(error.status)) {
                                const errorMessage = 'Chyba při vytváření SonarQube projektů: [' + error.error + '].';
                                this.notificationService.notifyError(errorMessage);
                                setTimeout(() => {
                                    this.notificationService.clearNotification(errorMessage);
                                }, 12000);
                            }
                            this.getProjects();
                        }
                    ).add(() => {
                    this.isLoading = false;
                });
            }
        })
    }

    deleteSonarQubeProjectsSelected() {

        const dialogRef = this.dialog.open(WarningModalComponentSQ, {
            width: '500px',
            data: {isSonarQube: true, isDeleting: true}
        });

        dialogRef.afterClosed().subscribe(result => {

            if (result) {
                this.isLoading = true;
                const idArray: number[] = this.collectSelectedIds();
                this.http.post<Array<number>>('/api/sonarqube/delete-projects', {ids: idArray})
                    .subscribe(data => {
                            if (data.length == idArray.length) {
                                this.notificationService.notify('SonarQube projekty zmazány úspešne.');
                            } else {
                                this.notificationService.notifyError('SonarQube projekty byli neúspěšne zmazány pro projekty s id: (' + idArray.filter(value => !data.includes(value)) + ').');
                            }
                            this.getProjects();
                            setTimeout(() => {
                                this.notificationService.clearNotification();
                            }, 12000);
                        },
                        error => {
                            console.error('Couldn\'t archive because', error);
                            if (!this.httpErrorService.ignoreError(error.status)) {
                                const errorMessage = 'Chyba při mazání SonarQube projektů: [' + error.error + '].';
                                this.notificationService.notifyError(errorMessage);
                                setTimeout(() => {
                                    this.notificationService.clearNotification(errorMessage);
                                }, 12000);
                            }
                            this.getProjects();
                        }
                    ).add(() => {
                    this.isLoading = false;
                });
            }
        })
    }


    collectSelectedIds() {
        const idArray: number[] = [];
        this.selectedProjects.forEach((project: Project) => {
            idArray.push(project.id);
        });
        return idArray;
    }

    indeterminate() {
        this.indeterminateV = this.selectedProjects.size !== 0 && this.dataSource.data.length !== 0
            && this.selectedProjects.size !== this.dataSource.data.length;
    }

    switchSelected(project: Project) {
        project.selected = !project.selected;
        if (project.selected) {
            this.selectedProjects.add(project);
        } else {
            this.selectedProjects.delete(project);
        }
        this.indeterminate();
    }

    switchAll() {
        if (this.selectedProjects.size < this.dataSource.filteredData.length) {
            for (const pp of this.dataSource.filteredData) {
                pp.selected = true;
                this.selectedProjects.add(pp);
            }
        } else {
            for (const project of this.dataSource.filteredData) {
                project.selected = false;
                this.selectedProjects.delete(project);
            }
        }
        this.indeterminate();
    }

    createSonarQube(project: Project) {

        const dialogRef = this.dialog.open(WarningModalComponentSQ, {
            width: '500px',
            data: {isSonarQube: true, isDeleting: false}
        });
        dialogRef.afterClosed().subscribe(result => {

            if (result) {
                this.isLoading = true;
                this.http.post('/api/sonarqube/create', {projectId: project.id})
                    .subscribe(response => {
                        console.log('SonarQube project created successfully:', response);
                        this.notificationService.notify('SonarQube projekt vytvořen úspešne. Studenti byli automaticky přidáni.');
                        this.getProjects();
                        setTimeout(() => {
                            this.notificationService.clearNotification();
                        }, 12000);
                    }, error => {
                        console.log('Couldn\'t create because', error);
                        if (!this.httpErrorService.ignoreError(error.status)) {
                            const errorMessage = 'Chyba při vytváření SonarQube: [' + error.error + '].';
                            this.notificationService.notifyError(errorMessage);
                            setTimeout(() => {
                                this.notificationService.clearNotification(errorMessage);
                            }, 12000);
                        }
                        this.getProjects();
                    }).add(() => {
                    this.isLoading = false;
                });
            }
        });

    }


    filterBasic($event) {
        if ($event.target.value) {
            this.basicFilter = $event.target.value;
            sessionStorage.setItem('basicFilter', this.basicFilter);
            this.doFilter(this.basicFilter);
        } else {
            sessionStorage.setItem('basicFilter', '');
            this.doFilter('');
        }
    }

    filterCourse(course) {
        if (course != null) {
            this.courseFilter = course;
            sessionStorage.setItem('courseFilter', this.courseFilter);
        } else {
            sessionStorage.setItem('courseFilter', '');
            this.courseFilter = '';
        }
        this.doFilter(this.dataSource.filter);
    }

    filterLeader(leader) {
        if (leader != null) {
            this.leaderFilter = leader;
            sessionStorage.setItem('leaderFilter', this.leaderFilter);
        } else {
            sessionStorage.setItem('leaderFilter', '');
            this.leaderFilter = '';
        }
        this.doFilter(this.dataSource.filter);
    }


    filterPerson($event) {
        if ($event.target.value) {
            this.personFilter = $event.target.value;
            sessionStorage.setItem('personFilter', this.personFilter);
        } else {
            sessionStorage.setItem('personFilter', '');
            this.personFilter = '';
        }
        this.doFilter(this.dataSource.filter);
    }


    transformString(str: string) {
        return str.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    filterPersonFromProject(prj: Project, person: string) {
        const transformedFilter = this.transformString(person);
        for (const p of prj.enrolledStudents) {
            if (this.transformString(p.name).indexOf(transformedFilter) !== -1
                || this.transformString(p.loginCVUT).indexOf(transformedFilter) !== -1) {
                return true;
            }
        }
        return false;
    }

    clearFilters() {
        this.basicFilter = '';
        this.courseFilter = '';
        this.leaderFilter = '';
        this.personFilter = '';


        sessionStorage.setItem('basicFilter', '');
        sessionStorage.setItem('courseFilter', '');
        sessionStorage.setItem('personFilter', '');
        sessionStorage.setItem('leaderFilter', '');


        this.basicFilterControl.setValue('', {onlySelf: true, emitEvent: false});
        this.courseFilterControl.setValue('', {onlySelf: true, emitEvent: false});
        this.personFilterControl.setValue('', {onlySelf: true, emitEvent: false});
        this.leaderFilterControl.setValue('', {onlySelf: true, emitEvent: false});
        this.doFilter('_');
    }
}

